import React from 'react';
import PropTypes from 'prop-types';

export default class Stepper extends React.Component {
    static propTypes = {
        type: PropTypes.oneOf(['default', 'ui5']),

        value: PropTypes.number,
        minValue: PropTypes.number,
        maxValue: PropTypes.number,
        step: PropTypes.number,
        disabled: PropTypes.bool,

        onChange: PropTypes.func
    };

    static defaultProps = {
        type: 'default',
        value: 0,
        minValue: null,
        maxValue: null,
        step: 1,
        disabled: false
    }

    state = {
        value: this.props.value
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { value } = nextProps;
        if (value !== this.state.value) this.setValue(value);
    }

    setValue = (value) => {
        this.setState({value:value});
    }

    getValue = () => this.state.value

    onClickDec = () => {this.handleUserChangeValue(this.state.value - this.props.step)}
    onClickInc = () => {this.handleUserChangeValue(this.state.value + this.props.step)}

    handleUserChangeValue = (value) => {
        if (this.props.disabled) return;

        let newValue = value;
        if (!_.isNil(this.props.minValue) && newValue < this.props.minValue) newValue = this.props.minValue;
        else if (!_.isNil(this.props.maxValue) && newValue > this.props.maxValue) newValue = this.props.maxValue;

        this.setState({value:newValue}, ()=>{
            if (this.props.onChange) this.props.onChange(newValue);
        });
    }

    render() {
        const classes = Classes(this.props.className, {
            'stepper': this.props.type === 'default',
            'ui5-stepper': this.props.type === 'ui5',
            'is-disabled': this.props.disabled
        });

        return (
            <div className={classes}>
                <div className="step-dec" onClick={this.onClickDec}/>
                <div className="step-value">{this.state.value}</div>
                <div className="step-inc" onClick={this.onClickInc}/>
            </div>
        );
    }
}
